import ProductCardLoading from '@common/components/ProductCard/ProductCardLoading';
import Rupee from '@common/components/Rupee';
import { ShopAllContext, ShopAllProvider } from '@common/context/ShopAllContext';
import Arrow from '@common/images/downVector.svg';
import Filter from '@common/images/Filter.svg';
import CartImg from '@common/images/noProducts.svg';
import Sort from '@common/images/Sort.svg';
import { RootState } from '@common/store';
import { addProductToCart, subtractProductFromCart } from '@common/store/cart/slice';
import {
  fetchProductsRequest,
  // getProductQueryParamsInitialState,
  resetProductsStore,
} from '@common/store/products/slice';
import { addToast } from '@common/store/toasts/slice';
import { isMobile } from '@common/utils';
import { PRODUCTS_KEY } from '@common/utils/constants';
// import FilterBar from '@components/FilterBar';
import PageLayout from '@components/PageLayout';
import Pagination from '@components/Pagination';
import ProductCard from '@components/ProductCard';
import ShopAllSidebar from '@components/ShopAllSidebar';
import { ReactComponent as BreadCrumbArrow } from '@images/BackArrow.svg';
// import { ReactComponent as BreadcrumbRightArrow } from '@images/sArrow.svg';
import Image from '@lib/Image';
// import InfiniteScroll from '@lib/InfiniteScroll';
import InjectScript from '@lib/InjectScript';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AttributesModal from './AttributesModal';
import SortByModal from './SortByModal';

const ShopAll = () => {
  const {
    category,
    shopAllProductsSlice,
    // categories,
    // shopAttributes,
    // priceLimits,
    computedSortOptions: { SELECTED_SORT_OPTION, UNSELECTED_SORT_OPTIONS },
    TOTAL_ATTRIBUTES_APPLIED,
    computedFacetProperties: { FACET_TAGS, onFacetTagClick },
    computedPriceProperties: { PRICE_TAG, onPriceTagClick },
    computedCategoryProperties: { CATEGORY_TAGS, onFacetTagClick: onCategoryTagClick },
  } = useContext(ShopAllContext);
  const cart = useSelector(({ cart }: RootState) => cart);
  const storeInfo = useSelector(({ storeInfo }: RootState) => storeInfo);
  const dispatch = useDispatch();
  const [showAttributesModal, setShowAttributesModal] = useState(false);
  // const [showwebAttributesModal, setShowwebAttributesModal] = useState(false);
  const [showSortOptionsModal, setShowSortOptionsModal] = useState(false);
  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

  return (
    <PageLayout>
      <InjectScript others="shop" />

      <div className="container md:mx-auto py-32 hidden md:block">
        <div className="hidden md:flex items-center text-14 md:text-16 font-normal">
          <Link to="/" className="cursor-pointer text-theme font-semibold" color-customisation="page-body-text">
            Home
          </Link>
          <BreadCrumbArrow fill="black" className="mx-4 h-8 fill-black transform rotate-180" />
          <div className="text-disabled font-medium" color-customisation="page-body-text">
            <span className="shop-all-link">Shop All</span>
          </div>
        </div>
      </div>
      <div className="container flex md:mx-auto px-0 min-h-screen">
        <div className="hidden md:block md:w-308 md:mb-30 pt-20">
          <ShopAllSidebar category={category.category} hideCategory />
        </div>
        {showAttributesModal ? <AttributesModal closeModal={() => setShowAttributesModal(false)} /> : null}
        {showSortOptionsModal ? <SortByModal closeModal={() => setShowSortOptionsModal(false)} /> : null}
        <div className="relative w-full md:w-6/7 px-16">
          <div className="flex flex-col w-full h-auto">
            <div className="grid text-theme text-center grid-cols-2 md:hidden -mx-16 cursor-pointer border-b-2 border-subtheme mt-20">
              <div
                className=" p-8 border-r-2 border-subtheme font-semibold text-16"
                onClick={() => setShowSortOptionsModal(true)}
              >
                <div className="flex justify-center">
                  <span>
                    <img src={Sort} alt="Sort" className="m-4" />
                  </span>
                  <span className="ml-4" font-customisation="section-heading" color-customisation="page-heading">
                    Sort
                  </span>
                </div>
                <div>
                  {SELECTED_SORT_OPTION?.name != 'Select' && (
                    <div className="text-12 text-theme text-opacity-60 mt-10">{SELECTED_SORT_OPTION?.name}</div>
                  )}
                </div>
              </div>
              <div
                className=" p-8 font-semibold text-16"
                onClick={() => {
                  setShowAttributesModal(true);
                }}
              >
                <div className="flex justify-center">
                  <img src={Filter} alt="Filter" className="m-4" />
                  <span className="ml-4" font-customisation="section-heading" color-customisation="page-heading">
                    {TOTAL_ATTRIBUTES_APPLIED ? `Filter(${TOTAL_ATTRIBUTES_APPLIED})` : 'Filter'}
                  </span>
                </div>
                <div className="text-12 text-theme text-opacity-60 mt-10" font-customisation="para-text">
                  Apply filters
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <div className="flex justify-end items-center mr-52">
                <span
                  className="text-label font-medium mr-8 text-14 text-opacity-70"
                  font-customisation="para-text"
                  color-customisation="page-body-text"
                >
                  Sort
                </span>
                <div className="items-center relative cursor-pointer">
                  <div
                    className="flex my-6 px-12 py-8 bg-black tracking-196 uppercase text-14 font-bold bg-opacity-10 rounded-full"
                    onClick={() => {
                      setIsSortDropdownOpen(!isSortDropdownOpen);
                    }}
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                  >
                    <span>{SELECTED_SORT_OPTION?.name}</span>
                    <div className="cursor-pointer ml-10 w-20">
                      <Image className={'rounded w-full h-full'} src={Arrow} noDefaultDimensions alt="Down" />
                    </div>
                  </div>
                  <div className="">
                    {isSortDropdownOpen && (
                      <div
                        className="flex absolute right-0 flex-col w-186 p-6 border border-border bg-white z-40 rounded"
                        onMouseLeave={(e) => {
                          e.preventDefault();
                          setIsSortDropdownOpen(false);
                        }}
                      >
                        {UNSELECTED_SORT_OPTIONS.map((sortOption) => (
                          <div
                            className="flex text-black pl-8 h-46 font-semibold text-14 leading-26 items-center hover:bg-theme hover:bg-opacity-10"
                            font-customisation="para-text"
                            color-customisation="page-body-text"
                            key={sortOption.key}
                            onClick={() => {
                              sortOption.onClick();
                              setIsSortDropdownOpen(false);
                            }}
                          >
                            {sortOption.unSelectedName || sortOption.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex md:hidden py-16 items-center text-14 md:text-16 font-normal">
              <Link to="/" className="cursor-pointer text-theme font-semibold" color-customisation="page-body-text">
                Home
              </Link>
              <BreadCrumbArrow fill="black" className="mx-4 h-8 fill-black transform rotate-180" />
              <div className="text-disabled font-medium" color-customisation="page-body-text">
                <span className="shop-all-link">Shop All</span>
              </div>
            </div>
            {!shopAllProductsSlice?.isFetching && (
              <div
                className="opacity-40 text-12 md:-mt-30 hidden md:block md:ml-20 md:w-500 font-semibold"
                font-customisation="section-heading"
                color-customisation="page-heading"
              >
                {shopAllProductsSlice?.list?.count} results for <span className="shop-all">&quot;Shop All&quot;</span>
              </div>
            )}
            <div className="block">
              <div className="flex flex-wrap md:ml-10 items-center">
                {FACET_TAGS.map((facetTag) => (
                  <div
                    key={facetTag.facetKey}
                    className="flex mt-20 mr-10 bg-black md:w-auto items-center h-45 justify-between bg-opacity-10 cursor-pointer rounded-full px-14 py-4 mx-4 text-14"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                    onClick={() => {
                      onFacetTagClick(facetTag);
                    }}
                  >
                    <div className="justify-self-start">{facetTag.facetValue}</div>
                    <div className="justify-self-end font-semibold text-14 ml-2 mt-4 text-disabled">&#10005;</div>
                  </div>
                ))}
                {CATEGORY_TAGS.map((facetTag) => (
                  <div
                    key={facetTag.facetKey}
                    className="flex mt-20 mr-10 bg-black md:w-auto items-center h-45 justify-between bg-opacity-10 cursor-pointer rounded-full px-14 py-4 mx-4 text-14"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                    onClick={() => {
                      onCategoryTagClick(facetTag);
                    }}
                  >
                    <div className="justify-self-start">{facetTag.facetValue}</div>
                    <div className="justify-self-end font-semibold text-14 ml-2 mt-4 text-disabled">&#10005;</div>
                  </div>
                ))}

                {PRICE_TAG ? (
                  <div
                    className="flex mt-20 mr-10 bg-black md:w-auto items-center h-45 justify-between bg-opacity-10 cursor-pointer rounded-full px-14 py-4 mx-4 text-14"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                    onClick={(e) => {
                      e.preventDefault();
                      onPriceTagClick(PRICE_TAG);
                    }}
                  >
                    <div className="justify-self-start">
                      <Rupee value={PRICE_TAG.minPrice} /> &nbsp;<span>-</span> &nbsp;
                      <Rupee value={PRICE_TAG?.maxPrice} />
                    </div>
                    <div className="justify-self-end ml-4">
                      <div className="justify-self-end font-semibold text-14 ml-2 mt-4 text-disabled">&#10005;</div>
                    </div>
                  </div>
                ) : null}
                {TOTAL_ATTRIBUTES_APPLIED > 0 ? (
                  <span
                    className="cursor-pointer ml-10 mt-20 opacity-60 font-12 font-medium underline"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                    onClick={() => {
                      dispatch(
                        fetchProductsRequest({
                          storeKey: PRODUCTS_KEY.SHOP,
                          queryParams: {
                            ...shopAllProductsSlice?.currentQueryParams,
                            page: (shopAllProductsSlice?.currentQueryParams?.page ?? 0) + 1,
                          },
                        }),
                      );
                    }}
                  >
                    Clear All
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          {shopAllProductsSlice?.error ? (
            <div className="text-center text-bold border rounded m-100 p-25">{shopAllProductsSlice?.error}</div>
          ) : null}
          <div className="w-full md:mt-30">
            {!shopAllProductsSlice ||
              (shopAllProductsSlice?.isFetching ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                  <ProductCardLoading />
                  <ProductCardLoading />
                  <ProductCardLoading />
                </div>
              ) : (
                <>
                  {shopAllProductsSlice?.list?.results?.length ? (
                    <div
                      className={classnames(
                        'flex flex-wrap h-full justify-around  -mx-16 md:mx-0 border-t border-subtheme md:border-none',
                      )}
                    >
                      {shopAllProductsSlice?.list?.results?.map((product, index: number) => (
                        <div
                          className={classnames(
                            'py-16 px-16 md:pt-0 md:pb-30 w-1/2 md:w-auto md:mx-20 md:mt-20 border-b border-subtheme odd:border-r md:border-none flex justify-center',
                          )}
                          key={index}
                        >
                          <ProductCard
                            addToast={(...args) => dispatch(addToast(...args))}
                            product={product}
                            addProductToCart={(...args) => dispatch(addProductToCart(...args))}
                            subtractProductFromCart={(...args) => dispatch(subtractProductFromCart(...args))}
                            cartProductQuantity={cart.quantityByProductId[product.id] || 0}
                            storeInfo={storeInfo}
                            shopAll={'shopAll'}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div className="justify-flex text-14 text-center text-theme md:mt-150 mt-100">
                        <img className="m-auto h-100 mb-20" src={CartImg} alt="Empty cart" />
                        <h1
                          className="my-14 text-20 md:text-32 font-semibold text-theme"
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Coming Soon!
                        </h1>
                        <div
                          className="text-14 md:text-16 font-medium text-gray tracking-wide md:leading-50"
                          font-customisation="para-text"
                        >
                          We are yet to add products to this category.
                        </div>
                      </div>
                    </>
                  )}
                </>
              ))}
          </div>
          {isMobile() ? (
            (shopAllProductsSlice?.list?.results?.length > 8 ||
              shopAllProductsSlice?.list?.next ||
              shopAllProductsSlice?.list?.previous) && (
              <div className="h-100 mt-70">
                <Pagination
                  className="absolute left-0 text-12 bottom-0"
                  {...shopAllProductsSlice?.pagination}
                  onClick={(pageNumber) => {
                    dispatch(resetProductsStore(PRODUCTS_KEY.SHOP));
                    dispatch(
                      fetchProductsRequest({
                        storeKey: PRODUCTS_KEY.SHOP,
                        queryParams: {
                          ...shopAllProductsSlice?.currentQueryParams,
                          page: pageNumber,
                        },
                      }),
                    );
                  }}
                />
              </div>
            )
          ) : (
            <div className="h-100 mt-70">
              <Pagination
                className="absolute left-0 text-12 bottom-0"
                {...shopAllProductsSlice?.pagination}
                onClick={(pageNumber) => {
                  dispatch(resetProductsStore(PRODUCTS_KEY.SHOP));
                  dispatch(
                    fetchProductsRequest({
                      storeKey: PRODUCTS_KEY.SHOP,
                      queryParams: {
                        ...shopAllProductsSlice?.currentQueryParams,
                        page: pageNumber,
                      },
                    }),
                  );
                }}
              />
            </div>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

// eslint-disable-next-line
export default () => {
  return (
    <ShopAllProvider sortDefaultName="Sort" sortDefaultUnselectedName="Clear All">
      <ShopAll />
    </ShopAllProvider>
  );
};
